import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseAutocompleteControl } from '../base-autocomplete-control';
import { CRMPhuongXaClient, CRM_PhuongXaDto } from '../../api-connector/sso-connector';
import { PhuongXaService } from '../../services/phuong-xa.service';

@Component({
  selector: 'phuong-xa-control',
  templateUrl: './phuong-xa-control.component.html',
  styleUrls: ['./phuong-xa-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhuongXaControlComponent),
      multi: true,
    }
  ]
})
export class PhuongXaControlComponent extends BaseAutocompleteControl<CRM_PhuongXaDto> implements OnInit, ControlValueAccessor {

  @Input() maQuanHuyen?: string;
  @Input() maTinhThanh?: string;
  @Input() showOld?: string;

  private loadedCode: string | null = null;

  constructor(
    private service: PhuongXaService,
    private phuongXaClient: CRMPhuongXaClient
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Client-side filtering from service (limit 20 results)
   */
  protected fetchItems(searchValue: string): Observable<CRM_PhuongXaDto[]> {
    return this.service.getAll().pipe(
      map(() => {
        if (!this.maQuanHuyen) {
          return [];
        }
        return this.service.filterCRMWithTag(searchValue, this.maQuanHuyen, this.maTinhThanh).slice(0, 20);
      })
    );
  }

  /**
   * Override writeValue to handle code-based loading
   */
  writeValue(code: string | CRM_PhuongXaDto): void {
    if (!code) {
      this.control.setValue(null, { emitEvent: false });
      this.selectedItem = null;
      this.loadedCode = null;
      return;
    }

    if (code instanceof CRM_PhuongXaDto) {
      this.control.setValue(code, { emitEvent: false });
      this.selectedItem = code;
      this.loadedCode = code.maPhuongXa || null;
      return;
    }

    if (typeof code === 'string' && code !== this.loadedCode) {
      this.loadedCode = code || null;

      const cached = this.service.findByCode(code);
      if (cached) {
        this.control.setValue(cached, { emitEvent: false });
        this.selectedItem = cached;
      } else {
        this.phuongXaClient.getDetail(code).subscribe(
          result => {
            this.control.setValue(result, { emitEvent: false });
            this.selectedItem = result;
          },
          error => {
            console.error('Error loading ward:', error);
            this.control.setValue(null, { emitEvent: false });
            this.selectedItem = null;
          }
        );
      }
    }
  }

  getDisplayValue(item: CRM_PhuongXaDto | null): string {
    return item?.tenPhuongXa || '';
  }

  protected isValidItem(value: any): boolean {
    return value instanceof CRM_PhuongXaDto;
  }

  /**
   * Use client-side filtering
   */
  protected useClientSideFilter(): boolean {
    return true;
  }
}
